import { Component, OnInit, Inject } from '@angular/core';
import { BillingOrderControlService } from '../../../services/billing/billing-order-control.service';
import { BillingMedicalAppointmentProcedureLog } from '../../../model/billing/billing-medical-appointment-procedure-log';
import { LogView } from '../../../model/log-view';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-billing-log-view-dialog',
  templateUrl: './billing-log-view-dialog.component.html',
  styleUrls: ['./billing-log-view-dialog.component.css']
})
export class BillingLogViewDialogComponent implements OnInit {

  loadingValidationLogs: boolean;
  loading: boolean;
  invoicingStateLogs: BillingMedicalAppointmentProcedureLog[] = [];
  invoiceLogs: BillingMedicalAppointmentProcedureLog[] = [];
  validationLogs: LogView[] = [];

  constructor(  private billingOrderControlService: BillingOrderControlService
              , private notificationToastService: NotificationToastService
              , public dialogRef: MatDialogRef<BillingLogViewDialogComponent>
              , @Inject(MAT_DIALOG_DATA) public request: BillingLogViewDialogRequest) {
  }

  ngOnInit() {

    this.loadingValidationLogs = true;
    this.loading = true;

    this.billingOrderControlService.getValidationLogView(this.request.medicalAppointmentId)
        .then( (logs) => {
          this.validationLogs = logs;
          this.loadingValidationLogs = false;
        } , ( err ) => {
          this.loadingValidationLogs = false;
          this.notificationToastService.error(JSON.stringify(err.error), 'Actividades facturación');
         });

    this.billingOrderControlService.getBillingMedicalAppointmentLogsByBillingState(this.request.medicalAppointmentId)
    .then( (logs) => {
      this.invoicingStateLogs = logs.filter(l => !l.InvoiceNumber);
      this.invoiceLogs = logs.filter(l => l.InvoiceNumber);
      this.loading = false;
    } , ( err ) => {
      this.loading = false;
      this.notificationToastService.error(JSON.stringify(err.error), 'Actividades facturación');
     });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

}

export interface BillingLogViewDialogRequest {
  medicalAppointmentId: number;
  medicalAppointmentProcedureId: number;
}
